<p-floatLabel>
  <p-select #quesitonStateDropdown
      id="questionStateDropdown"
      name="questionStateDropdown"
      [options]="questionStates" 
      [disabled]="isDisabled" 
      [(ngModel)]="selectedQuestionState"
      [showClear]="!isRequired"
      [checkmark]="true"
      styleClass="w-100"
      (onChange)="onSelected()">
      <ng-template let-option pTemplate="item">
          {{ option.label }}
      </ng-template>
  </p-select>
  <label for="questionStateDropdown">
      <app-label-content [isRequired]="isRequired">
          {{ l('::State') }}
      </app-label-content>
  </label>
</p-floatLabel>